export const FOOD_MENU = [
    {
        id: "soups",
        label: "Soups",
        note: "Add on: chicken ₹89 · prawns ₹149",
        items: [
            { name: "Lahsuni Tamatar Ka Shorba", desc: "Smoky roasted tomatoes, coriander & royal cumin", price: "309" },
            { name: "Minestrone Magic", desc: "Seasonal vegetables, pasta, tomato broth & basil", price: "329" },
            { name: "Creamy Pepper Chicken", desc: "Fresh cream, herbs & pepper", price: "359", nv: true },
            { name: "Manchow Fiesta", desc: "Indo-Chinese delight, bok choy & garlic", price: "319" },
        ],
    },
    {
        id: "salads",
        label: "Salads",
        note: "Add on: chicken ₹89 · prawns ₹149",
        items: [
            { name: "Caesar Salad Pop", desc: "Cherry tomato, broccoli, mixed greens, olives, zucchini & parmesan", price: "409" },
            { name: "Apple-Of-My-Avo Salad", desc: "Avocado, green apple, quinoa, zucchini & bell pepper", price: "419" },
            { name: "Fabulous Fatoush Salad", desc: "Croissant, mixed greens, pita, zucchini, olives, bell pepper & hummus", price: "419" },
            { name: "Pesto Kissed Burrata Salad", desc: "Roasted mushrooms, rocket leaves, baby spinach, cherry & sundried tomatoes", price: "449" },
            { name: "Orange Nutty Chicken Salad", desc: "Apple, caramelised walnut, soaked almond & orange-lemon honey dressing", price: "479", nv: true },
            { name: "Mango Quinoa & Kale Salad", desc: "Spiced mango, smeared kale, golden quinoa, cottage cheese & spicy lemon vinaigrette", price: "449" },
            { name: "Spicy Mango & Thecha Paneer Salad", desc: "Sweet mango, Maharashtrian thecha paneer, arugula, avocado & mango-sesame dressing", price: "459" },
        ],
    },
    {
        id: "bowls",
        label: "Bowls",
        note: "Add on: chicken ₹89 · prawns ₹149",
        items: [
            { name: "Continental Crush", desc: "Herbed rice / quinoa, sautéed vegetables, mixed greens & mushroom creamy parmesan sauce", price: "449" },
            { name: "Oriental Charm", desc: "Stir-fried noodles / rice / quinoa, Asian greens, wok-tossed vegetables & sesame soy glaze", price: "449" },
            { name: "Hawaiian Chicken", desc: "Herbed rice / quinoa, corn salsa, red beans pico de gallo, fresh greens & pineapple jus", price: "489", nv: true },
            { name: "Pesto Perfection", desc: "Herbed rice / quinoa, basil pesto, corn salsa, red beans, cottage cheese & gherkin", price: "489" },
        ],
    },
    {
        id: "sandwiches",
        label: "Sandwiches",
        items: [
            { name: "Pop Club Sandwich", desc: "Three toasted slices piled with vegetable, cheese & coleslaw", price: "489" },
            { name: "Stacked Tandoori Fling", desc: "Spicy tandoori paneer / chicken patty in herbed focaccia with jalapeño, onion & tabasco", price: "469" },
            { name: "Chilli-Cheese Toast", desc: "Toasted bread, melted cheese, green chillies, onions, capsicum & butter", price: "369" },
            { name: "Cheese Loaded Garlic Bread", desc: "Garlic bread, melted cheese, assorted vegetables & herbs · served with fries / wedges", price: "399" },
        ],
    },
    {
        id: "quesadilla-rolls",
        label: "Quesadilla & Rolls",
        note: "Add on: chicken ₹89 · prawns ₹149",
        items: [
            { name: "Zesty Peri Quesadilla", desc: "", price: "549" },
            { name: "Tandoori on a Roll", desc: "Smoky char-grilled paneer / chicken & capsicum in tandoori spices · served with fries / wedges", price: "499" },
        ],
    },
    {
        id: "munchies",
        label: "Munchies",
        note: "Add on: chicken ₹89 · prawns ₹149",
        items: [
            { name: "Hummus N' Falafel Fun", desc: "Falafel, creamy hummus & pickled veggies", price: "449" },
            { name: "Fry Yeah", desc: "Potato fries, salty / cheesy / peri-peri", price: "349 / 369 / 359" },
            { name: "Potato Wedge-A-Licious", desc: "Crispy potato wedges with herb mayo", price: "369" },
            { name: "Hot Shot Corn", desc: "Crispy corn, spices & fresh herbs", price: "429" },
            { name: "Salt & Pepper Affair", desc: "Crispy veggie bites & fiery seasoning", price: "429" },
            { name: "Nacho Salsa", desc: "Crispy nachos, salsa & cheese", price: "409" },
            { name: "Chicky Chicken Blast", desc: "Chicken popcorn with spices", price: "449", nv: true },
            { name: "Butter Chicken Bomb", desc: "Mini chicken bombs with creamy butter filling", price: "489", nv: true },
            { name: "Fish & Chips", desc: "Golden fried fish with crispy chips", price: "629", nv: true },
            { name: "Masala Quickies", desc: "Papad / peanuts", price: "229" },
        ],
    },
    {
        id: "chaat",
        label: "Chaat",
        items: [
            { name: "Chatpata Dilli 6", desc: "Crispy tikki, meetha dahi, Delhi-style masalas", price: "429" },
            { name: "Burrata-e-Banaras", desc: "Burrata, papdi & Banarasi tomato chutney", price: "449" },
            { name: "Guac N' Papdi", desc: "Guacamole, crunchy papdi, sweet chutney & yoghurt bed", price: "429" },
            { name: "Smokin' Chicken Chaat", desc: "Charred chicken tikka, onion lachha & lemon chaat masala", price: "449", nv: true },
            { name: "Chatpata Palak Munch", desc: "Crispy spinach leaves, yoghurt bed, chutneys & masala dust", price: "389" },
        ],
    },
    {
        id: "street-food",
        label: "Street Food",
        items: [
            { name: "Keema Muska Bun", desc: "", price: "495", nv: true },
            { name: "Dabeli Patakha Wheels", desc: "", price: "405" },
            { name: "Vada Pav Slider", desc: "", price: "425" },
        ],
    },
    {
        id: "bao-dimsums",
        label: "Bao & Dimsums",
        items: [
            { name: "Chilli Paneer Bao", desc: "", price: "555" },
            { name: "Thai Chilli Chicken Bao", desc: "", price: "595", nv: true },
            { name: "Veg Dimsum", desc: "Tandoori / steamed / crumb fried", price: "515 / 495 / 505" },
            { name: "Chicken Blossom", desc: "Tandoori / steamed / crumb fried", price: "555 / 535 / 545", nv: true },
        ],
    },
    {
        id: "sushi",
        label: "Sushi Rolls",
        items: [
            { name: "Veg Tempura Tickle", desc: "Japanese cucumber, carrot, asparagus & cream cheese", price: "605" },
            { name: "Teriyaki Chicken Tempura", desc: "Grilled chicken, asparagus, carrots & cream cheese", price: "645", nv: true },
            { name: "Prawn Tempura Tango", desc: "Crispy prawns, asparagus, cream cheese & carrot", price: "745", nv: true },
            { name: "Chili Avo Kick", desc: "Avocado, asparagus & Japanese cucumber", price: "605" },
        ],
    },
    {
        id: "pasta",
        label: "Pasta",
        note: "Add on: chicken ₹89 · prawns ₹149 · whole wheat base ₹49",
        items: [
            { name: "Arrabbiata / Alfredo", desc: "Available in whole wheat pasta", price: "549" },
            { name: "Spaghetti Aglio Olio / Basil Pesto", desc: "", price: "509 / 539" },
            { name: "Mac & Cheese", desc: "", price: "569" },
            { name: "Baked Parma Rosa", desc: "Available in whole wheat pasta", price: "595" },
            { name: "Mushroom Cajun", desc: "Available in whole wheat pasta", price: "555" },
            { name: "Masala Macaroni", desc: "Macaroni in home-style Indian masala, onions & tomatoes", price: "509" },
        ],
    },
    {
        id: "burgers",
        label: "Burgers",
        items: [
            { name: "Avocado Veg", desc: "", price: "505" },
            { name: "Peri Peri Paneer", desc: "", price: "515" },
            { name: "Veg Surprise", desc: "", price: "485" },
            { name: "Peri Peri Chicken", desc: "", price: "545", nv: true },
        ],
    },
    {
        id: "pizzas",
        label: "Pizzas",
        note: "Add on: chicken ₹89 · prawns ₹149 · wheat base ₹49",
        items: [
            { name: "Margherita", desc: "Homemade tomato sauce, mozzarella, fresh basil & cherry tomato", price: "595" },
            { name: "Calabrese Verde / Pollo", desc: "Roasted peppers, zucchini, jalapeños, olives, buffalo mozzarella & rocket with pesto", price: "655" },
            { name: "Mediterranean Veg", desc: "Tomato sauce, mozzarella, zucchini, bell peppers, corn, onion & broccoli", price: "625" },
            { name: "Fire Roasted Tandoori Paneer / Chicken", desc: "Charred tandoori paneer / chicken, roasted peppers, onions & jalapeños", price: "645" },
            { name: "Fungi Di Bosco", desc: "Tomato sauce, mozzarella, mushrooms, garlic & oregano", price: "645" },
        ],
    },
    {
        id: "indian-small-plates",
        label: "Indian Small Plates",
        items: [
            { name: "Thecha-Astic Paneer Tikka", desc: "Charred paneer, green chilli thecha & creamy yoghurt drizzle", price: "549" },
            { name: "Hazari Paneer Tikka", desc: "Charred paneer, creamy cashew marinade & white pepper", price: "559" },
            { name: "Beetroot Dahi Ke Kabab", desc: "Deep-fried panko crumbs & aromatic spices", price: "519" },
            { name: "Lick-Nowi Galauti Kebabs (Veg)", desc: "Veggie kebabs, aromatic spices & mini warqi paratha", price: "549" },
            { name: "Cheesy Affair Paneer Tikka", desc: "Cottage cheese, cheese blend, bell pepper & Indian spices", price: "569" },
            { name: "Berrylicious Dahi Kebabs", desc: "Hung curd, dried cranberry & cardamom", price: "499" },
            { name: "Charred Mushroom", desc: "Kumbh mushrooms, herbed cheese filling & basil", price: "549" },
            { name: "Bhara Bhara Chaap", desc: "Charred soya, cottage cheese & green peas", price: "529" },
            { name: "Makhmali Chicken Magic", desc: "Charred chicken, hung curd, white pepper & cardamom", price: "599", nv: true },
            { name: "Akbari Chicken Tikka", desc: "Charred chicken, Mughlai spices & hung curd marinade", price: "589", nv: true },
            { name: "Lick-Nowi Galauti Kebabs (Chicken)", desc: "Minced chicken, royal spices & mini warqi paratha", price: "599", nv: true },
            { name: "Patiala Chicken", desc: "Charred chicken, butter tempering, Punjabi spices & rum", price: "609", nv: true },
            { name: "Murg-E-Tandoori", desc: "Whole leg, house tandoori masala, hung curd & lemon smoke", price: "609", nv: true },
            { name: "Roghini Seekh-E-Mutton", desc: "Spiced mutton seekh, ghee roast & ulta tawa paratha", price: "709", nv: true },
            { name: "Bhatti Murg Seekh Kebab", desc: "Minced chicken, bhatti-style marinade, charred onions & green chillies", price: "609", nv: true },
            { name: "Sizzling Ajwaini Fish", desc: "Basa / sole, yoghurt marinade, carom seeds, lemon & spices", price: "649 / 759", nv: true },
        ],
    },
    {
        id: "sharing-platters",
        label: "Sharing Platters",
        items: [
            { name: "Diwan-E-Khaas", desc: "Thecha-astic paneer tikka, bhara bhara chaap, charred mushroom, galauti kebabs & dahi kebabs", price: "1099" },
            { name: "Chinjabi Veg Platter", desc: "Cheesy affair paneer tikka, beetroot galouti, bhara bhara chaap, kataifi spring roll & tandoori dimsums", price: "1249" },
            { name: "Next-Gen Nawabi Platter", desc: "Ajwaini fish, murg bhatti seekh, makhmali chicken, galauti kebabs & akbari chicken tikka", price: "1349", nv: true },
            { name: "Chinjabi Non-Veg Platter", desc: "Makhmali chicken, bhatti murg seekh, tandoori chicken, kataifi cheese chicken spring roll & tandoori dimsums", price: "1499", nv: true },
        ],
    },
    {
        id: "oriental-small-plates",
        label: "Oriental Small Plates",
        note: "Add on: prawns ₹149",
        items: [
            { name: "Chini-Chilli Samosa", desc: "", price: "479" },
            { name: "Kataifi Spring Roll", desc: "", price: "479" },
            { name: "Spicy Paneer", desc: "", price: "499" },
            { name: "Chilli Cheese Mushroom", desc: "", price: "499" },
            { name: "Manchurian Dry", desc: "", price: "479" },
            { name: "Oriental Mix Green", desc: "", price: "469" },
            { name: "Honey Chilli Potato", desc: "", price: "469" },
            { name: "Thai Green Chilli Chicken Dry", desc: "", price: "569", nv: true },
            { name: "Oriental Supreme Chicken Satay", desc: "", price: "579", nv: true },
            { name: "Drums of Heaven", desc: "", price: "579", nv: true },
            { name: "Chilli Crispy Tangy Fish / Prawns", desc: "", price: "599 / 729", nv: true },
            { name: "Kataifi Cheese Chicken Spring Roll", desc: "", price: "579", nv: true },
            { name: "Chicken Manchurian Dry", desc: "", price: "569", nv: true },
        ],
    },
    {
        id: "indian-large-plates",
        label: "Indian Large Plates",
        items: [
            { name: "Esak Special Famous Dal Makhani", desc: "Kali urad, rajma, slow-simmered cream & white butter", price: "585" },
            { name: "Zaika Dal Tadka", desc: "Toor dal & lahsuni jeera tadka", price: "519" },
            { name: "Punjabi Chole", desc: "Chickpeas, tangy onion-tomato masala, dry spices & coriander", price: "575" },
            { name: "Shabnam Malai Beetroot Kofta", desc: "Beetroot malai koftas, khoya & dry fruits in creamy white gravy", price: "615" },
            { name: "Phool-e-Mussalam", desc: "Tandoori gobhi, creamy cashew base, almond garnish & saffron", price: "575" },
            { name: "Esak Ka Bhatti Paneer", desc: "Charred cottage cheese & spicy bhatti masala", price: "625" },
            { name: "Teen Mirch Paneer Lababdar", desc: "Cottage cheese, tomato cashew gravy, green & red chilli, black pepper", price: "615" },
            { name: "Lahsuni Bhutta Paalak", desc: "Makai, garlic, spinach purée & fresh cream", price: "595" },
            { name: "Shahi Matar Mushroom Methi Malai", desc: "Button mushroom & cashew base", price: "595" },
            { name: "Mili Juli Sabziyan", desc: "Seasonal vegetables, jeera tadka, fresh coriander & home spices", price: "575" },
            { name: "Tandoori Spicy Chaap Gravy", desc: "Soya chaap in charcoal-grilled spicy tomato-onion gravy", price: "595" },
            { name: "Esak-e-Butter Chicken", desc: "Tandoori chicken, kasuri methi, white butter & rich tomato cream", price: "685", nv: true },
            { name: "Murg Lababdar", desc: "Chicken tikka, spiced tomato gravy, onion-cashew base & cream finish", price: "675", nv: true },
            { name: "Rahra Gosht", desc: "Bone-in mutton, spiced keema gravy, roasted garam masala & coriander", price: "725", nv: true },
            { name: "Rogan-E-Josh", desc: "Slow-cooked mutton, Kashmiri spices, chilli rogan & browned onions", price: "715", nv: true },
            { name: "Lagan Ka Murg", desc: "Dum-cooked chicken, nutmeg, slow bhuna masala & brown onion", price: "675", nv: true },
            { name: "Murg Mussalam", desc: "Half chicken in tomato gravy topped with egg bhurji, saffron cream & almond-cashew paste", price: "695", nv: true },
            { name: "Keema Naan With Nihari", desc: "Slow-cooked mutton with nihari gravy, spiced keema & pizza naan", price: "795", nv: true },
        ],
    },
    {
        id: "continental-large-plates",
        label: "Continental Large Plates",
        note: "Add on: prawns ₹149",
        items: [
            { name: "Mushroom and Spinach Lasagne", desc: "Layered homemade lasagne, béchamel, concasse & parmesan mozzarella", price: "585" },
            { name: "À-la Princess", desc: "Cottage cheese, jalapeño, mushrooms, mashed potatoes, arrabbiata & creamy basil sauce", price: "605" },
            { name: "Grilled Peri Peri Chicken", desc: "African spice rub, citrus glaze & grilled vegetables", price: "645", nv: true },
            { name: "Coriander Chilli Lemon Grilled Fish", desc: "Basa / sole, coriander-chilli marinade & lemon butter", price: "665 / 799", nv: true },
            { name: "Crispy Chicken Maryland", desc: "Crispy fried chicken, mashed potatoes, broccoli & creamy basil parmesan sauce", price: "655", nv: true },
        ],
    },
    {
        id: "chinese-mains",
        label: "Chinese Mains",
        items: [
            { name: "Noodles, Chilli Garlic / Hakka", desc: "", price: "505" },
            { name: "Manchurian Gravy", desc: "", price: "575" },
            { name: "Diced Chicken, Schezwan / Black Pepper", desc: "", price: "625", nv: true },
            { name: "Chilli Paneer in Hot Garlic Gravy", desc: "", price: "545" },
            { name: "Fried Rice, Vegetable / Schezwan", desc: "", price: "505" },
            { name: "Lemon Butter Garlic Prawns", desc: "", price: "845", nv: true },
        ],
    },
    {
        id: "sizzlers",
        label: "Sizzlers",
        note: "Add on: chicken ₹89 · prawns ₹149",
        items: [
            { name: "Chicken Hong Kong", desc: "Chilli garlic / hakka", price: "655", nv: true },
            { name: "Chilli Oyster Cottage Cheese", desc: "", price: "605" },
            { name: "Chimichanga", desc: "Crispy golden-fried tortilla stuffed with flavourful fillings", price: "615" },
        ],
    },
    {
        id: "biryani",
        label: "Biryani e Khaas",
        items: [
            { name: "Hyderabadi Gosht", desc: "Black cardamom, browned onion, stone-ground masala & saffron", price: "759", nv: true },
            { name: "Handi Murg", desc: "Smoked butter, khada masala, browned onion & saffron", price: "659", nv: true },
            { name: "Achari Subz", desc: "Seasonal vegetables, achari masala & saffron", price: "595" },
        ],
    },
    {
        id: "rice-raita",
        label: "Rice & Raita",
        items: [
            { name: "Steamed Rice", desc: "", price: "299" },
            { name: "Peas Pulao", desc: "", price: "349" },
            { name: "Boondi / Mix Raita", desc: "", price: "255" },
            { name: "Plain Curd", desc: "", price: "215" },
        ],
    },
    {
        id: "breads-chutneys",
        label: "Breads & Chutneys",
        items: [
            { name: "Tandoori Roti", desc: "Plain / butter", price: "55 / 65" },
            { name: "Missi Roti", desc: "", price: "75" },
            { name: "Naan", desc: "Plain / butter / garlic / kalonji", price: "85 / 95 / 105 / 105" },
            { name: "Laccha Paratha", desc: "Plain / mirchi / pudina", price: "85 / 95 / 95" },
            { name: "Keema Naan", desc: "", price: "295", nv: true },
            { name: "Paratha", desc: "Paneer / mix veg / aloo / chur chur", price: "169 / 149 / 189 / 189" },
            { name: "Stuffed Naan", desc: "Aloo / mix / paneer", price: "169 / 189 / 199" },
            { name: "Royal Jodhpur Parantha", desc: "", price: "169" },
            { name: "Green Mango Chutney", desc: "", price: "69" },
            { name: "Tomato-Green Chilli-Dhaniya Chutney", desc: "Homemade style, sibatta", price: "69" },
            { name: "Roasted Tomato Chutney", desc: "", price: "69" },
        ],
    },
    {
        id: "desserts",
        label: "Desserts",
        items: [
            { name: "Shahi Tukda", desc: "", price: "349" },
            { name: "Noor Pirni", desc: "", price: "305" },
            { name: "Esak Style Biscoff Cheese Cake", desc: "", price: "349" },
            { name: "Esak Style Tiramisu", desc: "Walnut brownie layered with silky mascarpone cream, dusted with premium cocoa", price: "339" },
            { name: "Dessert Platter", desc: "Tiramisu, biscoff cheesecake, butter croissant & fudgy brownie with coffee ice cream", price: "599" },
        ],
    },
];
